<template>
  <nav id="menu">
    <header class="nav-title">Navigation</header>
    <ul class="side-nav-items">
      <side-nav-item to="/" text="Home" />
      <side-nav-item to="/dein-beitrag" text="Dein Beitrag">
        <ul class="side-nav-items side-nav-sub-items">
          <li class="side-nav-item">
            <side-nav-item to="/dein-beitrag/zusagen" text="Rückmeldung" />
            <side-nav-item to="/dein-beitrag/wunschliste" text="Wunschliste" />
            <side-nav-item to="/dein-beitrag/kuchen" text="Kuchen" />
            <side-nav-item to="/dein-beitrag/programm" text="Programmbeitrag" />
            <side-nav-item to="/dein-beitrag/playlist" text="Party-Playlist" />
<!--            <side-nav-item to="/dein-beitrag/upload" text="Foto-Upload" />-->
          </li>
        </ul>
      </side-nav-item>
      <side-nav-item to="/fragen" text="Fragen"/>
      <side-nav-item to="/corona" text="Corona" />
      <side-nav-item to="/galerie" text="Galerie" />
    </ul>
  </nav>
</template>

<script>
import SideNavItem from '@/components/technical/SideNavItem.vue';

export default {
  name: 'Menu',

  components: {
    SideNavItem,
  },

  mounted() {
    const els = document.querySelectorAll('#menu .side-nav-item a');

    els.forEach(node => node.addEventListener('click',
      () => this.$emit('close')));
  },

  unmounted() {
    const els = document.querySelectorAll('#menu .side-nav-item a');

    els.forEach(node => node.removeEventListener('click', () => this.$emit('close')));
  },
};
</script>

<style lang="scss">
  #menu {
    position: fixed;
    top: 0;
    right: 0;

    width: 350px;
    height: 100%;

    overflow-y: auto;

    background-color: #e9e7e2;
    box-shadow: inset 3px 0 8px 0 rgba(51, 51, 51, .4);
    z-index: -2;

    text-align: left;

    header.nav-title {
      padding: 1rem 2rem;

      font-family: 'Sitka Heading', serif;
      font-weight: bold;
      font-size: 1.5rem;

      border-bottom: 1px solid darkgray;
    }

    ul.side-nav-items {
      margin: 0;
      padding: 0;

      list-style-type: none;
    }
  }
</style>
